module.exports = __webpack_public_path__ + "assets/3b72b303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nature2.jpg
// module id = 100
// module chunks = 0